import { render, staticRenderFns } from "./MailGroup.vue?vue&type=template&id=b10aaa1e"
import script from "./MailGroup.vue?vue&type=script&lang=js"
export * from "./MailGroup.vue?vue&type=script&lang=js"
import style0 from "./MailGroup.vue?vue&type=style&index=0&id=b10aaa1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports